<template>
  <gmap-marker class="marker-list-element"
    :position="marker.position"
    :draggable="false"
    :icon="icon"
    :cursor="cursor"
    :zIndex="zIndex()"
    :opacity="opacity()"
    @click="handleClick($event)"
  >
    <!-- :label="marker.name" -->
  </gmap-marker>
</template>

<script>
import bus from "@/api/bus";

export default {
  /**
   * marker: marker object with its data, whether place or chapter
   * type: if it is a 'place' or 'chapter'. Expects string.
   * mode: how the user should interact with the markers. Expect string.
   * mode = 'select': emits selected marker on click.
   * mode = 'link': links to the marker page.
   * mode = 'fixed': makes marker untouchable.
   * mode default: does nothing.
   */
  props: ['marker', 'type', 'mode'],
  data() {
    return {
      cursor: 'pointer',
      event: null
    }
  },
  computed: {
    icon() {
      if(this.type == 'place')
        return { url: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png' };
      else if (this.type == 'chapter')
        return null; // fazer ícones nossos pra capítulo e grupo
      else
        return null;
    }
  },
  created() {
    if(this.mode == 'fixed') {
      this.cursor = 'default';
    }
  },
  methods: {
    handleClick(event) {
      this.event = event
      if (this.type == 'place' && this.mode == 'select') {
        bus.emit.place(this.marker);
        // console.log(event)
      }
      else if(this.mode == 'link') {
        this.$router.push({ name: this.type, params: { id: this.marker.id }});
      }
      else if(this.mode == 'zoom') {
        if(this.marker.zoom)  bus.emit.zoomIn(this.marker.position, this.marker.zoom);
      }

    },
    zIndex() {
      if(this.type == 'chapter')
        return 999;
      // else
      //   return 1;
    },
    opacity() {
      // if(this.type == 'chapter')
      //   return 0.5;
    },
  },
}
</script>
